import React from 'react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PersonIcon from '@mui/icons-material/Person';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { TFunction } from 'i18next';

export type FilterChipItem = {
    icon: React.JSX.Element;
    tooltip: string;
    value: string;
    colorKey: number;
};

const pushIf = (chips: FilterChipItem[], condition: boolean, chip: FilterChipItem) => {
    if (condition) chips.push(chip);
};

const isMeaningfulId = (id: unknown) =>
    id !== undefined && id !== null && id !== 0 && id !== '' && id !== -1 && id !== '-1';

const resolveOrderStatusValues = (request: any, orderStatusList: any[] | undefined): string => {
    const statusIds: Array<string | number> = Array.isArray(request.orderStatusIds)
        ? request.orderStatusIds
        : String(request.orderStatusIds)
              .split(',')
              .map((id) => id.trim())
              .filter(Boolean);

    return statusIds
        .map((statusId: string | number) => {
            const matchedStatus = (orderStatusList || []).find(
                (status: any) => +status.orderStatusId === +statusId
            );
            return matchedStatus?.backendDescriptionKey || String(statusId);
        })
        .join(', ');
};

export const buildOrdersFilterChips = (
    request: any,
    t: TFunction,
    orderStatusList: any[] | undefined
): FilterChipItem[] => {
    const chips: FilterChipItem[] = [];

    pushIf(chips, !!(request.startDate || request.endDate), {
        icon: <CalendarTodayIcon />,
        tooltip: `${t('general.startDate')} / ${t('general.endDate')}`,
        value: `${request.startDate || '?'}  →  ${request.endDate || '?'}`,
        colorKey: 0,
    });
    pushIf(chips, !!request.orderNumber, {
        icon: <ReceiptLongIcon />,
        tooltip: t('general.orderNo'),
        value: request.orderNumber,
        colorKey: 1,
    });

    if (request.Barcodes && (Array.isArray(request.Barcodes) ? request.Barcodes.length > 0 : request.Barcodes)) {
        const barcodeStr = Array.isArray(request.Barcodes) ? request.Barcodes.join(', ') : request.Barcodes;
        chips.push({
            icon: <QrCodeScannerIcon />,
            tooltip: t('searchService.barcode'),
            value: barcodeStr,
            colorKey: 2,
        });
    }

    pushIf(chips, !!request.sellerName, {
        icon: <StorefrontIcon />,
        tooltip: t('general.sellerName'),
        value: request.sellerName,
        colorKey: 3,
    });
    pushIf(chips, !!(request.shippingListNo && request.shippingListNo !== 0), {
        icon: <ListAltIcon />,
        tooltip: t('general.shippingNo'),
        value: String(request.shippingListNo),
        colorKey: 4,
    });
    pushIf(chips, !!request.storeCode, {
        icon: <StorefrontIcon />,
        tooltip: t('general.storeCode'),
        value: request.storeCode,
        colorKey: 5,
    });
    pushIf(chips, !!(request.PhoneNumberbyDelivery && request.PhoneNumberbyDelivery !== 0), {
        icon: <LocalShippingIcon />,
        tooltip: t('general.shippingPhoneNumber'),
        value: String(request.PhoneNumberbyDelivery),
        colorKey: 6,
    });
    pushIf(chips, !!(request.PhoneNumberbyCustomerId && request.PhoneNumberbyCustomerId !== 0), {
        icon: <PhoneAndroidIcon />,
        tooltip: t('general.customerPhoneNumber'),
        value: String(request.PhoneNumberbyCustomerId),
        colorKey: 7,
    });
    pushIf(chips, !!request.DPackageCargoShipmentCode, {
        icon: <Inventory2Icon />,
        tooltip: t('general.dPackageNo'),
        value: request.DPackageCargoShipmentCode,
        colorKey: 8,
    });
    pushIf(chips, !!request.TrackingCode, {
        icon: <GpsFixedIcon />,
        tooltip: t('general.mpCargoShipmentNo'),
        value: request.TrackingCode,
        colorKey: 9,
    });

    if (request.orderStatusIds) {
        chips.push({
            icon: <ListAltIcon />,
            tooltip: t('customerInformation.status'),
            value: resolveOrderStatusValues(request, orderStatusList),
            colorKey: 4,
        });
    }

    pushIf(chips, isMeaningfulId(request.paymentMethodId), {
        icon: <PersonIcon />,
        tooltip: t('general.paymentMethod'),
        value: String(request.paymentMethodId),
        colorKey: 7,
    });
    pushIf(chips, isMeaningfulId(request.shippingCompanyId), {
        icon: <LocalShippingIcon />,
        tooltip: t('general.cargoCompany'),
        value: String(request.shippingCompanyId),
        colorKey: 6,
    });
    pushIf(chips, !!request.IsDKoli, {
        icon: <CheckCircleOutlineIcon />,
        tooltip: 'D-Koli',
        value: 'D-Koli',
        colorKey: 5,
    });

    return chips;
};
